/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Evidence_Vendor_ClaimInputs */

const en_directory_evidence_vendor_claim = /** @type {(inputs: Directory_Evidence_Vendor_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendor claim`)
};

const zh_directory_evidence_vendor_claim = /** @type {(inputs: Directory_Evidence_Vendor_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`厂商声明`)
};

/**
* | output |
* | --- |
* | "Vendor claim" |
*
* @param {Directory_Evidence_Vendor_ClaimInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_evidence_vendor_claim = /** @type {((inputs?: Directory_Evidence_Vendor_ClaimInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Evidence_Vendor_ClaimInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_evidence_vendor_claim(inputs)
	return zh_directory_evidence_vendor_claim(inputs)
});
export { directory_evidence_vendor_claim as "directory.evidence.vendor_claim" }